module.exports = __webpack_public_path__ + "img/Picture8.7226491e.jpg";